function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "compare",
  d: "M25.59,5.841H16.613v-1.8a1.8,1.8,0,0,0-1.8-1.8H4.045a1.8,1.8,0,0,0-1.8,1.8V22a1.8,1.8,0,0,0,1.8,1.8h8.977v1.8a1.8,1.8,0,0,0,1.8,1.8H25.59a1.8,1.8,0,0,0,1.8-1.8V7.636A1.8,1.8,0,0,0,25.59,5.841ZM4.045,13.92H9.584L7.268,16.245l1.266,1.266,4.488-4.488L8.534,8.534,7.268,9.8l2.316,2.325H4.045V4.045H14.818V22H4.045ZM14.818,25.59v-1.8a1.8,1.8,0,0,0,1.8-1.8V7.636H25.59v8.079H20.051l2.316-2.325L21.1,12.124l-4.488,4.488L21.1,21.1l1.266-1.266-2.316-2.325H25.59V25.59Z",
  transform: "translate(-2.25 -2.25)",
  fill: "#ac1ede"
});

var SvgCompare = function SvgCompare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.135,
    height: 25.135,
    viewBox: "0 0 25.135 25.135",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compare.da50e8de.svg";
export { ForwardRef as ReactComponent };